<script>
import { percentage_format } from "@/utils.js";
export default {
  name: "visit-frequency",
  props: ["items"],
  methods: {
    setKeys() {
      let data = [ "First Visit" , "Second Visit", "Third Visit", "Four to Ninth Visits", "More than Ten Visits", "Visit Retention"]
      return data;
    },
    setTotalValue() {
      let first_visit =
        this.items && this.items.first_visit ? this.items.first_visit : 0;
      let second_visit =
        this.items && this.items.second_visit ? this.items.second_visit : 0;
      let third_visit =
        this.items && this.items.third_visit ? this.items.third_visit : 0;
      let four_to_ninth_visits =
        this.items && this.items.four_to_ninth_visits
          ? this.items.four_to_ninth_visits
          : 0;
      let more_than_ten_visits =
        this.items && this.items.more_than_ten_visits
          ? this.items.more_than_ten_visits
          : 0;
      let total =
        first_visit +
        second_visit +
        third_visit +
        four_to_ninth_visits +
        more_than_ten_visits;
      return parseFloat(total);
    },
    calculateData(value) {
      let percentage = 0;
      if (this.setTotalValue() > 0) {
        let total = parseFloat(value) / this.setTotalValue();
        percentage = total * 100;
        percentage.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
        return percentage.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
      }
      return percentage;
    }
  },
  computed: {
    first_visit() {
      return this.items && this.items.first_visit ? this.items.first_visit : 0;
    },
    four_to_ninth_visits() {
      return this.items && this.items.four_to_ninth_visits
        ? this.items.four_to_ninth_visits
        : 0;
    },
    more_than_ten_visits() {
      return this.items && this.items.more_than_ten_visits
        ? this.items.more_than_ten_visits
        : 0;
    },
    second_visit() {
      return this.items && this.items.second_visit
        ? this.items.second_visit
        : 0;
    },
    third_visit() {
      return this.items && this.items.third_visit ? this.items.third_visit : 0;
    },
    visit_retention() {
      let percentage =
        this.items && this.items.visit_retention
          ? this.items.visit_retention
          : 0;
      return percentage.toFixed(4).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
    chartData() {
      return [
        this.calculateData(this.first_visit),
        this.calculateData(this.second_visit),
        this.calculateData(this.third_visit),
        this.calculateData(this.four_to_ninth_visits),
        this.calculateData(this.more_than_ten_visits),
        this.visit_retention * 100
      ];
    },
    chartSeries() {
      return [
        {
          name: "Visit Frequency",
          data: this.chartData
        }
      ];
    },
    chartOptions() {
      let categories = this.setKeys();
      // console.log(categories);
      return {
        chart: {
          height: 350,
          type: "bar",
          toolbar: {
            show: true,
            tools: {
              download:
                '<i class="flaticon2-download-2" style="color:gray;" title="Download"></i>',
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset:
                '<i class="flaticon2-refresh-button" style="color:gray;"></i>',
              customIcons: []
            }
          }
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            dataLabels: {
              position: "top" // top, center, bottom
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            return percentage_format(val);
          },
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#304758"]
          }
        },
        xaxis: {
          categories: categories,
          position: "bottom",
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          crosshairs: {
            fill: {
              type: "gradient",
              gradient: {
                colorFrom: "#d8e3f0",
                colorTo: "#bed1E6",
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5
              }
            }
          },
          tooltip: {
            enabled: true
          }
        },
        yaxis: {
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          labels: {
            show: false,
            formatter: function(val) {
              return percentage_format(val);
            }
          }
        },
        title: {
          text: "",
          floating: true,
          offsetY: 330,
          align: "center",
          style: {
            color: "#444"
          }
        }
      };
    },
    totalAverageVisit() {
      return percentage_format(this.visit_retention * 100);
    }
  }
};
</script>

<template>
  <div class="example">
    <v-card-title>Visit Frequency</v-card-title>
    <v-card-subtitle>
      <strong>{{ totalAverageVisit }}</strong> of customers in this segment have
      visited your restaurant more than once.
    </v-card-subtitle>
    <apexchart
      type="bar"
      height="350"
      :options="chartOptions"
      :series="chartSeries"
    ></apexchart>
  </div>
</template>
